import { pathToRegexp } from "path-to-regexp/dist.es2015";

export const matchRoutes = (routes, pathname) => {
  const route = routes.filter((item) => {
    const regexp = pathToRegexp(item.route);
    return !!regexp.exec(pathname);
  });
  if (route.length > 0) {
    return route[0];
  }
  return null;
};

export const groupBySize = (elements, size) => {
  if (elements.length === 0) return [];
  return elements.reduce((acc, curr) => {
    if (
      typeof acc === "object" &&
      acc.constructor === Object &&
      typeof curr === "object" &&
      curr.constructor === Object
    ) {
      return [[acc, curr]];
    }
    if (Array.isArray(acc) && acc.length < 2) {
      const lastArr = acc[acc.length - 1];
      if (lastArr.length < size) {
        return [[...lastArr, curr]];
      }
      return [lastArr, [curr]];
    }
    if (Array.isArray(acc) && acc.length >= 2) {
      const lastArr = acc[acc.length - 1];
      if (lastArr.length < size) {
        return [...acc.slice(0, acc.length - 1), [...lastArr, curr]];
      }
      return [...acc, [curr]];
    }
    return [];
  });
};

export const isObject = (object) => {
  return object != null && typeof object === "object";
};

export const deepEqual = (object1, object2) => {
  const keys1 = Object.keys(object1);
  const keys2 = Object.keys(object2);

  if (keys1.length !== keys2.length) return false;

  // eslint-disable-next-line no-restricted-syntax
  for (const key of keys1) {
    const val1 = object1[key];
    const val2 = object2[key];
    const areObjects = isObject(val1) && isObject(val2);
    if (
      (areObjects && !deepEqual(val1, val2)) ||
      (!areObjects && val1 !== val2)
    )
      return false;
  }
  return true;
};

export const capitalize = (word) => {
  return word?.charAt(0)?.toUpperCase() + word?.substring(1);
};

export const toCapitalizedWords = (word) => {
  const words = word?.match(/[A-Za-z][a-z]*/g) || [];

  return words.map(capitalize).join(" ");
};

export const humanize = (name) => {
  const words = name?.match(/[A-Za-z0-9][A-Za-z0-9.]*/g) || [];
  return words?.map(capitalize).join(" ");
};

export const camelize = (str) => {
  return str
    ?.replace(/(?:^\w|[A-Z]|\b\w)/g, (word, index) => {
      return index === 0 ? word.toLowerCase() : word.toUpperCase();
    })
    .replace(/\s+/g, "");
};

export const snakeize = (str) => {
  return str.replace(/[A-Z]/g, (letter) => `_${letter.toLowerCase()}`);
};

export const humanToSnake = (str) => {
  const noSpaceStr = str.replace(/\s/g, "");
  return noSpaceStr.replace(/[A-Z]/g, (letter) => `_${letter.toLowerCase()}`);
};

export const sortBooleanColumns = (defaultA, defaultB) => {
  if (defaultA > defaultB) return 1;
  if (defaultA < defaultB) return -1;
  return 0;
};
